/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map } from "lodash";
import { useSelector } from "react-redux";
import { forwardRef, useImperativeHandle, useState } from "react";
import SwitchR from "react-switch";
import Button from "@mui/material/Button";
import toast from "react-hot-toast";

const AntecedentesHeredoFamiliares = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    const [chkProblemasAudMadre, setchkProblemasAudMadre] = useState(
      props?.probAudicionMadre ? props.probAudicionMadre : false
    );
    const [chkEnfNeoplasicasMadre, setchkEnfNeoplasicasMadre] = useState(
      props?.enfNeoplasicasMadre ? props.enfNeoplasicasMadre : false
    );
    const [chkEnfMetabolicasMadre, setchkEnfMetabolicasMadre] = useState(
      props?.enfMetabolicasMadre ? props.enfMetabolicasMadre : false
    );
    const [chkProbRenalesMadre, setchkProbRenalesMadre] = useState(
      props?.probRenalesMadre ? props.probRenalesMadre : false
    );
    const [chkEnfCardioMadre, setchkEnfCardioMadre] = useState(
      props?.enfCardioMadre ? props.enfCardioMadre : false
    );
    const [chkEnfPsiqMadre, setchkEnfPsiqMadre] = useState(
      props?.enfPsiqMadre ? props.enfPsiqMadre : false
    );
    const [chkProbNingunaMadre, setchkProbNingunaMadre] = useState(
      props?.enfNingunaMadre ? props.enfNingunaMadre : false
    );
    const [txtOtrasHeredoMadre, settxtOtrasHeredoMadre] = useState(
      props?.otrasHeredoMadre ? props.otrasHeredoMadre : ""
    );
    const [chkProblemasAudPadre, setchkProblemasAudPadre] = useState(
      props?.probAudicionPadre ? props.probAudicionPadre : false
    );
    const [chkEnfNeoplasicasPadre, setchkEnfNeoplasicasPadre] = useState(
      props?.enfNeoplasicasPadre ? props.enfNeoplasicasPadre : false
    );
    const [chkEnfMetabolicasPadre, setchkEnfMetabolicasPadre] = useState(
      props?.enfMetabolicasPadre ? props.enfMetabolicasPadre : false
    );
    const [chkProbRenalesPadre, setchkProbRenalesPadre] = useState(
      props?.probRenalesPadre ? props.probRenalesPadre : false
    );
    const [chkEnfCardioPadre, setchkEnfCardioPadre] = useState(
      props?.enfCardioPadre ? props.enfCardioPadre : false
    );
    const [chkEnfPsiqPadre, setchkEnfPsiqPadre] = useState(
      props?.enfPsiqPadre ? props.enfPsiqPadre : false
    );
    const [chkProbNingunaPadre, setchkProbNingunaPadre] = useState(
      props?.enfNingunaPadre ? props.enfNingunaPadre : false
    );
    const [txtOtrasHeredoPadre, settxtOtrasHeredoPadre] = useState(
      props?.otrasHeredoPadre ? props.otrasHeredoPadre : ""
    );

    const [chkProblemasAudHermanos, setchkProblemasAudHermanos] = useState(
      props?.probAudicionHermanos ? props.probAudicionHermanos : false
    );
    const [chkEnfNeoplasicasHermanos, setchkEnfNeoplasicasHermanos] = useState(
      props?.enfNeoplasicasHermanos ? props.enfNeoplasicasHermanos : false
    );
    const [chkEnfMetabolicasHermanos, setchkEnfMetabolicasHermanos] = useState(
      props?.enfMetabolicasHermanos ? props.enfMetabolicasHermanos : false
    );
    const [chkProbRenalesHermanos, setchkProbRenalesHermanos] = useState(
      props?.probRenalesHermanos ? props.probRenalesHermanos : false
    );
    const [chkEnfCardioHermanos, setchkEnfCardioHermanos] = useState(
      props?.enfCardioHermanos ? props.enfCardioHermanos : false
    );
    const [chkEnfPsiqHermanos, setchkEnfPsiqHermanos] = useState(
      props?.enfPsiqHermanos ? props.enfPsiqHermanos : false
    );
    const [chkProbNingunaHermanos, setchkProbNingunaHermanos] = useState(
      props?.enfNingunaHermanos ? props.enfNingunaHermanos : false
    );
    const [txtOtrasHeredoHermanos, settxtOtrasHeredoHermanos] = useState(
      props?.otrasHeredoHermanos ? props.otrasHeredoHermanos : ""
    );

    const [txtFamiliarHeredofamiliares, settxtFamiliarHeredofamiliares] = useState(
      props?.nombreFamiliarHeredo ? props.nombreFamiliarHeredo : ""
    );
    const [chkProblemasAudFamiliar, setchkProblemasAudFamiliar] = useState(
      props?.probAudicionFamiliar ? props.probAudicionFamiliar : false
    );
    const [chkEnfNeoplasicasFamiliar, setchkEnfNeoplasicasFamiliar] = useState(
      props?.enfNeoplasicasFamiliar ? props.enfNeoplasicasFamiliar : false
    );
    const [chkEnfMetabolicasFamiliar, setchkEnfMetabolicasFamiliar] = useState(
      props?.enfMetabolicasFamiliar ? props.enfMetabolicasFamiliar : false
    );
    const [chkProbRenalesFamiliar, setchkProbRenalesFamiliar] = useState(
      props?.probRenalesFamiliar ? props.probRenalesFamiliar : false
    );
    const [chkEnfCardioFamiliar, setchkEnfCardioFamiliar] = useState(
      props?.enfCardioFamiliar ? props.enfCardioFamiliar : false
    );
    const [chkEnfPsiqFamiliar, setchkEnfPsiqFamiliar] = useState(
      props?.enfPsiqFamiliar ? props.enfPsiqFamiliar : false
    );
    const [txtOtrasHeredoFamiliar, settxtOtrasHeredoFamiliar] = useState(
      props?.otrasHeredoFamiliar ? props.otrasHeredoFamiliar : ""
    );

    const ValidaForm = () => {
      if (
        !chkProblemasAudMadre &&
        !chkProbRenalesMadre &&
        !chkEnfNeoplasicasMadre &&
        !chkEnfCardioMadre &&
        !chkEnfMetabolicasMadre &&
        !chkEnfPsiqMadre &&
        !chkProbNingunaMadre
      ) {
        toast.error(
          "selecciona por lo menos una opción para la sección de ::Enfermedades de la madre::"
        );
        return null;
      }

      if (
        !chkProblemasAudPadre &&
        !chkProbRenalesPadre &&
        !chkEnfNeoplasicasPadre &&
        !chkEnfCardioPadre &&
        !chkEnfMetabolicasPadre &&
        !chkEnfPsiqPadre &&
        !chkProbNingunaPadre
      ) {
        toast.error(
          "selecciona por lo menos una opción para la sección de ::Enfermedades del padre::"
        );
        return null;
      }
      if (
        !chkProblemasAudHermanos &&
        !chkProbRenalesHermanos &&
        !chkEnfNeoplasicasHermanos &&
        !chkEnfCardioHermanos &&
        !chkEnfMetabolicasHermanos &&
        !chkEnfPsiqHermanos &&
        !chkProbNingunaHermanos
      ) {
        toast.error(
          "selecciona por lo menos una opción para la sección de ::Enfermedades de hermanos::"
        );
        return null;
      }
      const data = {
        probAudicionMadre: chkProblemasAudMadre ? 1 : 0,
        probRenalesMadre: chkProbRenalesMadre ? 1 : 0,
        enfNeoplasicasMadre: chkEnfNeoplasicasMadre ? 1 : 0,
        enfCardioMadre: chkEnfCardioMadre ? 1 : 0,
        enfMetabolicasMadre: chkEnfMetabolicasMadre ? 1 : 0,
        enfPsiqMadre: chkEnfPsiqMadre ? 1 : 0,
        enfNingunaMadre: chkProbNingunaMadre ? 1 : 0,
        otrasHeredoMadre: txtOtrasHeredoMadre,

        probAudicionPadre: chkProblemasAudPadre ? 1 : 0,
        probRenalesPadre: chkProbRenalesPadre ? 1 : 0,
        enfNeoplasicasPadre: chkEnfNeoplasicasPadre ? 1 : 0,
        enfCardioPadre: chkEnfCardioPadre ? 1 : 0,
        enfMetabolicasPadre: chkEnfMetabolicasPadre ? 1 : 0,
        enfPsiqPadre: chkEnfPsiqPadre ? 1 : 0,
        enfNingunaPadre: chkProbNingunaPadre ? 1 : 0,
        otrasHeredoPadre: txtOtrasHeredoPadre,

        probAudicionHermanos: chkProblemasAudHermanos ? 1 : 0,
        probRenalesHermanos: chkProbRenalesHermanos ? 1 : 0,
        enfNeoplasicasHermanos: chkEnfNeoplasicasHermanos ? 1 : 0,
        enfCardioHermanos: chkEnfCardioHermanos ? 1 : 0,
        enfMetabolicasHermanos: chkEnfMetabolicasHermanos ? 1 : 0,
        enfPsiqHermanos: chkEnfPsiqHermanos ? 1 : 0,
        enfNingunaHermanos: chkProbNingunaHermanos ? 1 : 0,
        otrasHeredoHermanos: txtOtrasHeredoHermanos,

        probAudicionFamiliar: chkProblemasAudFamiliar ? 1 : 0,
        probRenalesFamiliar: chkProbRenalesFamiliar ? 1 : 0,
        enfNeoplasicasFamiliar: chkEnfNeoplasicasFamiliar ? 1 : 0,
        enfCardioFamiliar: chkEnfCardioFamiliar ? 1 : 0,
        enfMetabolicasFamiliar: chkEnfMetabolicasFamiliar ? 1 : 0,
        enfPsiqFamiliar: chkEnfPsiqFamiliar ? 1 : 0,
        otrasHeredoFamiliar: txtOtrasHeredoFamiliar,
        nombreFamiliarHeredo: txtFamiliarHeredofamiliares,
      };

      Next(data);
      return data;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      const data = {
        probAudicionMadre: chkProblemasAudMadre ? 1 : 0,
        probRenalesMadre: chkProbRenalesMadre ? 1 : 0,
        enfNeoplasicasMadre: chkEnfNeoplasicasMadre ? 1 : 0,
        enfCardioMadre: chkEnfCardioMadre ? 1 : 0,
        enfMetabolicasMadre: chkEnfMetabolicasMadre ? 1 : 0,
        enfPsiqMadre: chkEnfPsiqMadre ? 1 : 0,
        enfNingunaMadre: chkProbNingunaMadre ? 1 : 0,
        otrasHeredoMadre: txtOtrasHeredoMadre,

        probAudicionPadre: chkProblemasAudPadre ? 1 : 0,
        probRenalesPadre: chkProbRenalesPadre ? 1 : 0,
        enfNeoplasicasPadre: chkEnfNeoplasicasPadre ? 1 : 0,
        enfCardioPadre: chkEnfCardioPadre ? 1 : 0,
        enfMetabolicasPadre: chkEnfMetabolicasPadre ? 1 : 0,
        enfPsiqPadre: chkEnfPsiqPadre ? 1 : 0,
        enfNingunaPadre: chkProbNingunaPadre ? 1 : 0,
        otrasHeredoPadre: txtOtrasHeredoPadre,

        probAudicionHermanos: chkProblemasAudHermanos ? 1 : 0,
        probRenalesHermanos: chkProbRenalesHermanos ? 1 : 0,
        enfNeoplasicasHermanos: chkEnfNeoplasicasHermanos ? 1 : 0,
        enfCardioHermanos: chkEnfCardioHermanos ? 1 : 0,
        enfMetabolicasHermanos: chkEnfMetabolicasHermanos ? 1 : 0,
        enfPsiqHermanos: chkEnfPsiqHermanos ? 1 : 0,
        enfNingunaHermanos: chkProbNingunaHermanos ? 1 : 0,
        otrasHeredoHermanos: txtOtrasHeredoHermanos,

        probAudicionFamiliar: chkProblemasAudFamiliar ? 1 : 0,
        probRenalesFamiliar: chkProbRenalesFamiliar ? 1 : 0,
        enfNeoplasicasFamiliar: chkEnfNeoplasicasFamiliar ? 1 : 0,
        enfCardioFamiliar: chkEnfCardioFamiliar ? 1 : 0,
        enfMetabolicasFamiliar: chkEnfMetabolicasFamiliar ? 1 : 0,
        enfPsiqFamiliar: chkEnfPsiqFamiliar ? 1 : 0,
        otrasHeredoFamiliar: txtOtrasHeredoFamiliar,
        nombreFamiliarHeredo: txtFamiliarHeredofamiliares,
      };

      Back(data);
    };

    return (
      <>
        <Grid container spacing={2}>
          {/* Primera columna: Label */}
          <Grid item xs={12} md={3} lg={2}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Enfermedades de la madre:
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Segunda fila: 3 columnas con SwitchR */}
          <Grid item xs={12} md={10} lg={10}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProblemasAudMadre(!chkProblemasAudMadre)}
                    checked={chkProblemasAudMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Auditivas
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfNeoplasicasMadre(!chkEnfNeoplasicasMadre)}
                    checked={chkEnfNeoplasicasMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Neoplásicas (Cáncer)
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfMetabolicasMadre(!chkEnfMetabolicasMadre)}
                    checked={chkEnfMetabolicasMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Metabólicas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Tercera fila: 3 columnas con SwitchR */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbRenalesMadre(!chkProbRenalesMadre)}
                    checked={chkProbRenalesMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Renales
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfCardioMadre(!chkEnfCardioMadre)}
                    checked={chkEnfCardioMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Cardiovasculares
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfPsiqMadre(!chkEnfPsiqMadre)}
                    checked={chkEnfPsiqMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Psiquiátricas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Cuarta fila: SwitchR para Ninguna */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbNingunaMadre(!chkProbNingunaMadre)}
                    checked={chkProbNingunaMadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Ninguna
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <br />
            {/* Quinta fila: TextArea ocupando 3 columnas */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  label="Otras"
                  disabled={desactivar}
                  variant="outlined"
                  multiline
                  rows={3}
                  value={txtOtrasHeredoMadre}
                  onChange={(e) => settxtOtrasHeredoMadre(e.target.value)}
                  fullWidth
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label */}
          <Grid item xs={12} md={2} lg={2}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Enfermedades del padre:
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Segunda fila: 3 columnas con SwitchR */}
          <Grid item xs={12} md={10} lg={10}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProblemasAudPadre(!chkProblemasAudPadre)}
                    checked={chkProblemasAudPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Auditivas
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfNeoplasicasPadre(!chkEnfNeoplasicasPadre)}
                    checked={chkEnfNeoplasicasPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Neoplásicas (Cáncer)
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfMetabolicasPadre(!chkEnfMetabolicasPadre)}
                    checked={chkEnfMetabolicasPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Metabólicas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Tercera fila: 3 columnas con SwitchR */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbRenalesPadre(!chkProbRenalesPadre)}
                    checked={chkProbRenalesPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Renales
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfCardioPadre(!chkEnfCardioPadre)}
                    checked={chkEnfCardioPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Cardiovasculares
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfPsiqPadre(!chkEnfPsiqPadre)}
                    checked={chkEnfPsiqPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Psiquiátricas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Cuarta fila: SwitchR para Ninguna */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbNingunaPadre(!chkProbNingunaPadre)}
                    checked={chkProbNingunaPadre}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Ninguna
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <br />
            {/* Quinta fila: TextArea ocupando 3 columnas */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  label="Otras"
                  disabled={desactivar}
                  variant="outlined"
                  multiline
                  rows={3}
                  value={txtOtrasHeredoPadre}
                  onChange={(e) => settxtOtrasHeredoPadre(e.target.value)}
                  fullWidth
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label */}
          <Grid item xs={12} md={2} lg={2}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Enfermedades de hermanos:
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Segunda fila: 3 columnas con SwitchR */}
          <Grid item xs={12} md={10} lg={10}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProblemasAudHermanos(!chkProblemasAudHermanos)}
                    checked={chkProblemasAudHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Auditivas
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfNeoplasicasHermanos(!chkEnfNeoplasicasHermanos)}
                    checked={chkEnfNeoplasicasHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Neoplásicas (Cáncer)
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfMetabolicasHermanos(!chkEnfMetabolicasHermanos)}
                    checked={chkEnfMetabolicasHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Metabólicas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Tercera fila: 3 columnas con SwitchR */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbRenalesHermanos(!chkProbRenalesHermanos)}
                    checked={chkProbRenalesHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Renales
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfCardioHermanos(!chkEnfCardioHermanos)}
                    checked={chkEnfCardioHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Cardiovasculares
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfPsiqHermanos(!chkEnfPsiqHermanos)}
                    checked={chkEnfPsiqHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Psiquiátricas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Cuarta fila: SwitchR para Ninguna */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbNingunaHermanos(!chkProbNingunaHermanos)}
                    checked={chkProbNingunaHermanos}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Ninguna
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <br />
            {/* Quinta fila: TextArea ocupando 3 columnas */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  label="Otras"
                  disabled={desactivar}
                  variant="outlined"
                  multiline
                  rows={3}
                  value={txtOtrasHeredoHermanos}
                  onChange={(e) => settxtOtrasHeredoHermanos(e.target.value)}
                  fullWidth
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label */}
          <Grid item xs={12} md={2} lg={2}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Enfermedades de otros familiares:
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Primera fila: Input "¿Qué familiar?" ocupando toda la fila */}
          <Grid item xs={12} md={10} lg={10}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="¿Qué familiar?"
                  disabled={desactivar}
                  variant="outlined"
                  value={txtFamiliarHeredofamiliares}
                  onChange={(e) => settxtFamiliarHeredofamiliares(e.target.value)}
                  fullWidth
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            {/* Segunda fila: 3 columnas con SwitchR */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProblemasAudFamiliar(!chkProblemasAudFamiliar)}
                    checked={chkProblemasAudFamiliar}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Auditivas
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfNeoplasicasFamiliar(!chkEnfNeoplasicasFamiliar)}
                    checked={chkEnfNeoplasicasFamiliar}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Neoplásicas (Cáncer)
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfMetabolicasFamiliar(!chkEnfMetabolicasFamiliar)}
                    checked={chkEnfMetabolicasFamiliar}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Metabólicas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>

            {/* Tercera fila: 3 columnas con SwitchR */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkProbRenalesFamiliar(!chkProbRenalesFamiliar)}
                    checked={chkProbRenalesFamiliar}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Renales
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfCardioFamiliar(!chkEnfCardioFamiliar)}
                    checked={chkEnfCardioFamiliar}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Cardiovasculares
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                  <SwitchR
                    disabled={desactivar}
                    onChange={() => setchkEnfPsiqFamiliar(!chkEnfPsiqFamiliar)}
                    checked={chkEnfPsiqFamiliar}
                    height={20}
                    width={50}
                    handleDiameter={18}
                    onColor="#605CA9"
                  />
                  <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                    Psiquiátricas
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <br />
            {/* Cuarta fila: TextArea ocupando toda la fila */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Otras"
                  disabled={desactivar}
                  variant="outlined"
                  multiline
                  rows={3}
                  value={txtOtrasHeredoFamiliar}
                  onChange={(e) => settxtOtrasHeredoFamiliar(e.target.value)}
                  fullWidth
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {vista === "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={desactivar}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default AntecedentesHeredoFamiliares;
